module.exports = __webpack_public_path__ + "static/media/s36.079a4c0e.jpg";